export default __webpack_public_path__ + "static/media/arrow-right.e14f898e.svg";